import "./projectList.scss"
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import { getProjects } from '../../services/projectService';

// Helper for optimizing thumbnail URLs directly (like Gallery.jsx)
const cldOptimize = (url, w = 1200) => {
    if (url && url.includes('res.cloudinary.com') && url.includes('/upload/')) {
        return url.replace('/upload/', `/upload/w_${w},c_fill,f_auto,q_auto/`);
    }
    return url;
};

const ProjectList = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [projectsData, setProjectsData] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchList = async () => {
            setLoading(true);
            try {
                const projects = await getProjects();
                setProjectsData(projects);
            } catch (err) {
                console.error("Error fetching projects:", err);
                setError("Network error");
            }
            setLoading(false);
        };
        fetchList();
    }, []);

    const setUnlockedStatus = (projectLink) => {
        try {
            if (!localStorage.getItem('password')) return false;
            
            const allowedStr = localStorage.getItem('allowed_projects');
            if (allowedStr) {
                const allowed = JSON.parse(allowedStr);
                // If they have explicit access to this project, or they have admin/dashboard access
                if (allowed.includes(projectLink) || allowed.includes("/dashboard")) {
                    return true;
                }
            }
            return false;
        } catch (e) {
            return false;
        }
    };

    if (loading) return <div className="ProjectListContainer"><h1 style={{ color: "white", textAlign: "center", marginTop: "50px" }}>Loading...</h1></div>;
    if (error) return <div className="ProjectListContainer"><h1 style={{ color: "white", textAlign: "center", marginTop: "50px" }}>{error}</h1></div>;

    let images = [];
    let hasLockedProjects = false;
    const url = location.pathname;
    const currentSection = url.split('/')[1];

    if (projectsData && projectsData.length > 0) {
        projectsData.forEach((item, index) => {
            // Filter by section if we are on a specific section page (e.g. /personal or /work)
            // If the URL is just /home or /, we show everything.
            if (currentSection && !["home", "credentials", "dashboard", ""].includes(currentSection)) {
                // Ensure item.link exists and matches current section
                if (!item.link) return;
                const itemSection = item.link.split('/')[1];
                if (itemSection !== currentSection) return;
            }

            const unlocked_status = setUnlockedStatus(item.link);

            // Skip rendering this project entirely if it's hidden and not unlocked
            if (item.hidden && !unlocked_status) {
                hasLockedProjects = true;
                return;
            }

            const project_name = item.link.split('/').at(-1).toLowerCase();
            let thumbnail = item.thumbnail;
            let description = item.description || `${project_name.charAt(0).toUpperCase() + project_name.slice(1)}`;

            if (!thumbnail) thumbnail = `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'ddlk1txel'}/image/upload/Projects/project_${project_name}`;

            images.push({
                id: index,
                imgSrc: cldOptimize(thumbnail, 1200),
                description: description,
                link: item.link,
                hidden: item.hidden,
                unlocked: unlocked_status,
            });
        });

        if (hasLockedProjects && !localStorage.getItem('password')) {
            images.push({
                id: 'unannounced-placeholder',
                imgSrc: cldOptimize(`https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'ddlk1txel'}/image/upload/Projects/project_coming`, 1200),
                description: 'Unannounced Project',
                link: '',
                hidden: true,
                unlocked: false,
            });
        }
    }

    const openProject = (item) => {
        if (item.hidden) {
            if (item.unlocked) {
                navigate(item.link);
            } else {
                window.dispatchEvent(new CustomEvent('trigger-login', { detail: { item } }));
            }
        } else {
            navigate(item.link);
        }
    };

    return (
        <div className="ProjectListContainer">
            <ul className="gallery">
                {images.map((item, index) => {
                    return (
                        <li className="imgFrame" key={item.id} onClick={() => { openProject(item); }}>

                            <img className="img" src={item.imgSrc} alt={item.description} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />

                            <div className={item.hidden ? "locked" : "locked hidden"}>
                                <div className={item.unlocked ? "unLocked true" : "unLocked"}>
                                    <LockOutlinedIcon className="icon" />
                                </div>
                                <div className={item.unlocked ? "unLocked" : "unLocked true"}>
                                    <LockOpenOutlinedIcon className="icon" />
                                </div>
                            </div>

                            <div className={item.unlocked ? "descriptionContent unlocked" : "descriptionContent locked"}>
                                <label className="description">{item.description}</label>
                            </div>
                            <div className={item.unlocked ? "descriptionContent locked" : "descriptionContent unlocked"}>
                                <label className="description">{item.description}</label>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
};

export default ProjectList;